/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {FC} from 'react'
import {ListTable} from '../../../modules/comman/ListComponenets/ListTable'
import {connect} from 'react-redux'
import * as vendor from '../redux/VendorRedux'
import {Tooltip, Popconfirm, Input} from 'antd'
import {Switch} from 'antd'
import {Button} from 'antd'
import {UserOutlined, EditOutlined, DeleteOutlined} from '@ant-design/icons'
import {
  changeStatusVendorData,
  deleteVendorData,
  editVendorData,
  getVendorData,
  getSearchVendorData,
} from '../redux/VendorCRUD'
import {config} from '../../../comman/constants'
import {InputSearchText} from '../../../modules/comman/formComponents/InputSearchText'
import {History, LocationState} from 'history'
import {InputButtonComponent} from '../../../modules/comman/formComponents/InputButtonComponent'
import {withRouter} from 'react-router-dom'
import {RouteComponentProps} from 'react-router'
import {Toaster} from '../../../modules/comman/components/ToasterNoti'
import {CommanModal} from '../../../modules/comman/components/ModalComponent'
import {EditVendorForm} from './EditVendorForm'

const {Search} = Input
const PRIMARY_COLOR = config.buttonPrimaryColor
const TEXT_PRIMARY_COLOR = config.buttonTextPrimaryColor
interface IRecordsTableProps {
  vendorData: any
  vendorDataTotal: number
  vendorLoading: boolean
  setListVendorData: (vendorData: any) => void
  setListVendorDataTotal: (vendorDataTotal: number) => void
  setVendorLoading: (vendorLoading: boolean) => void
  history?: History<LocationState>
}

interface IRecordsTableState {
  searchText: string
  isLoading: boolean
  startIndex: number
  limitNumber: number
  pagination: {
    pageSize: number
    current: number
  }
  vendorSelectedData: any
}

type PathParamsType = {
  param1: string
}
class ListVendorData extends React.Component<
  RouteComponentProps<PathParamsType> & IRecordsTableProps,
  IRecordsTableState
> {
  constructor(props: any) {
    super(props)

    this.state = {
      isLoading: false,
      startIndex: 0,
      limitNumber: 50,
      pagination: {
        pageSize: 50,
        current: 1,
      },
      searchText: '',
      vendorSelectedData: null,
    }
  }

  public handleTableChange = (pagination: any, filters: any) => {
    this.setState(
      {
        pagination,
      },
      () => this.getListVendorData(pagination)
    )
  }

  public getListVendorData = async (pagination: any) => {
    const {searchText} = this.state

    console.log('tempCounter && counter --> ', this.tempCounter, this.counter)
    const start = pagination.current * pagination.pageSize - pagination.pageSize
    const end = pagination.pageSize

    this.setState(
      {
        isLoading: true,
        startIndex: start,
        limitNumber: end,
      },
      async () => {
        if (searchText && searchText !== '') {
          this.listVendorSearchData(start, end)
        } else {
          this.listVendorData(start, end)
        }
      }
    )
  }

  public listVendorData = async (start: number, end: any) => {
    const {setVendorLoading} = this.props
    try {
      const {setListVendorData, setListVendorDataTotal} = this.props
      await setVendorLoading(true)
      let vendorData = await getVendorData(start, end)
      if (vendorData.data) {
        await setListVendorData(vendorData.data.docs)
        await setListVendorDataTotal(vendorData.data.totalDocs)
      }
    } catch (e) {
      console.log('!!!!Error', e)
    } finally {
      await setVendorLoading(false)
    }
  }

  public listVendorSearchData = async (start: number, end: any) => {
    const {setVendorLoading} = this.props
    try {
      const {setListVendorData, setListVendorDataTotal} = this.props
      const {searchText} = this.state

      await setVendorLoading(true)
      let vendorData = await getSearchVendorData(start, end, searchText)
      if (vendorData.data) {
        await setListVendorData(vendorData.data.docs)
        await setListVendorDataTotal(vendorData.data.totalDocs)
      }
    } catch (e) {
      console.log('!!!!Error', e)
    } finally {
      await setVendorLoading(false)
    }
  }

  public onSearchChange = async (value: string) => {
    try {
      this.setState(
        {
          searchText: value,
        },
        () => {
          this.listVendorSearchData(0, 50)
        }
      )
    } catch (e) {
      console.log('!!!!Error', e)
    }
  }

  public onCreateVendor = () => {
    const {history} = this.props
    history.push('/vendor/create')
  }

  public deleteVendor = async (item: any) => {
    const {setVendorLoading} = this.props
    try {
      const {startIndex, limitNumber, searchText} = this.state

      await setVendorLoading(true)
      await deleteVendorData(item._id)

      Toaster({
        type: 'success',
        title: 'VENDOR',
        description: 'Deleted SuccessFully',
      })

      if (searchText != null && searchText !== '') {
        this.listVendorSearchData(startIndex, limitNumber)
        return
      }
      this.listVendorData(startIndex, limitNumber)
    } catch (e) {
      console.log('!!!!Error', e)
    } finally {
      await setVendorLoading(false)
    }
  }

  public onChangeStatus = async (item: any, checked: boolean) => {
    const {setVendorLoading} = this.props
    try {
      const {startIndex, limitNumber, searchText} = this.state

      await setVendorLoading(true)
      await changeStatusVendorData(item._id, checked)

      Toaster({
        type: 'success',
        title: 'VENDOR',
        description: 'Status changed successFully',
      })

      if (searchText != null && searchText !== '') {
        this.listVendorSearchData(startIndex, limitNumber)
        return
      }
      this.listVendorData(startIndex, limitNumber)
    } catch (e) {
      console.log('!!!!Error', e)
    } finally {
      await setVendorLoading(false)
    }
  }

  public onEditSubmit = async (values: any) => {
    const {setVendorLoading} = this.props
    try {
      const {startIndex, limitNumber, searchText} = this.state

      await setVendorLoading(true)
      await editVendorData(values)

      Toaster({
        type: 'success',
        title: 'VENDOR',
        description: 'Edited SuccessFully',
      })

      if (searchText != null && searchText !== '') {
        this.listVendorSearchData(startIndex, limitNumber)
        return
      }
      this.listVendorData(startIndex, limitNumber)
    } catch (e) {
      console.log('!!!!Error', e)
    } finally {
      await setVendorLoading(false)
    }
  }

  public showEditModal = async (item: any) => {
    this.setState({
      vendorSelectedData: item,
    })
  }

  public closeEditModal = async () => {
    this.setState({
      vendorSelectedData: null,
    })
  }

  counter = 0
  tempCounter = 0
  public columns = [
    {
      title: 'Sr. No.',
      key: 'serial_number',
      fixed: window.innerWidth < 768 ? false : true,
      width: 80,
      render: (text: any, item: any, index: number) => {
        return (
          <div>
            <span>{++index + this.tempCounter}</span>
          </div>
        )
      },
    },
    {
      title: 'Vendor Name',
      key: 'Vendor Name',
      fixed: window.innerWidth < 768 ? false : true,
      render: (text: any, item: any, index: number) => {
        return (
          <div>
            <strong>
              {item.first_name && item.last_name
                ? `${item.first_name} ${item.last_name}`
                : item.first_name
                ? item.first_name
                : '-'}
            </strong>
          </div>
        )
      },
    },
    {
      title: 'Email',
      key: 'email',
      width: 250,
      render: (text: any, item: any, index: number) => {
        return <div>{item.email ? item.email : '-'}</div>
      },
    },
    {
      title: 'isActive',
      key: 'isActive',
      render: (text: any, item: any, index: number) => {
        return (
          <div>
            {item.is_active != null ? (
              <Tooltip placement='bottom' title='Vendor Activation'>
                {
                  <Switch
                    checked={item.is_active}
                    style={{
                      backgroundColor: item.is_active ? PRIMARY_COLOR : '#bababa',
                    }}
                    onChange={(checked: boolean) => {
                      //call onChange Method with item
                      this.onChangeStatus(item, checked)
                    }}
                  />
                }
              </Tooltip>
            ) : (
              '-'
            )}
          </div>
        )
      },
    },
    {
      title: 'Actions',
      width: 130,
      key: 'action',
      render: (text: any, item: any, index: number) => {
        return (
          <div style={{display: 'inline-block', width: '100%'}}>
            <div style={{float: 'left', marginRight: '5px'}}>
              <Tooltip placement='bottom' title='Edit'>
                <Button
                  shape='circle'
                  icon={<EditOutlined />}
                  onClick={() => {
                    this.showEditModal(item)
                  }}
                />
              </Tooltip>
            </div>
            <div style={{float: 'left', marginRight: '5px'}}>
              <Tooltip placement='bottom' title='Delete'>
                <Popconfirm
                  onConfirm={() => {
                    //call delete vendor api
                    this.deleteVendor(item)
                  }}
                  title='Are you sure you want to delete vendor?'
                >
                  <Button shape='circle' icon={<DeleteOutlined />} />
                </Popconfirm>
              </Tooltip>
            </div>
          </div>
        )
      },
    },
  ]

  public render() {
    const {vendorData, vendorDataTotal, vendorLoading} = this.props
    const {searchText, vendorSelectedData} = this.state

    return (
      <div>
        <div className='container'>
          <div className='card card-custom'>
            <div className='card-header'>
              <h3 className='card-title table-card-title' style={{width: '25%'}}>
                <InputSearchText
                  onChange={(value: string) => {
                    this.onSearchChange(value)
                  }}
                  placeholder='Search Vendor'
                  input={{
                    value: searchText,
                  }}
                />
              </h3>
              <div className='card-toolbar'>
                <InputButtonComponent
                  onClick={() => {
                    this.onCreateVendor()
                  }}
                >
                  Add Vendor
                </InputButtonComponent>
              </div>
            </div>
            <div className='card-body'>
              <div style={{overflowX: 'auto'}}>
                <ListTable
                  rowKey={(record: {_id: any}) => record._id}
                  onChange={this.handleTableChange}
                  column={this.columns}
                  paginationConfig={{
                    total: vendorDataTotal,
                    showSizeChanger: true,
                    pageSize: this.state.pagination.pageSize,
                    current: this.state.pagination.current,
                  }}
                  isLoading={vendorLoading}
                  dataSource={vendorData}
                  counter={this.counter}
                  tempCounter={this.tempCounter}
                  isScroll={false}
                  scrollWidth={1200}
                />
                <div>
                  <CommanModal
                    show={vendorSelectedData ? true : false}
                    handleClose={() => {
                      this.closeEditModal()
                    }}
                    title={'Edit Vendor'}
                    submitText={'Save Changes'}
                  >
                    <div>
                      {vendorSelectedData && (
                        <EditVendorForm
                          data={vendorSelectedData}
                          onSubmit={(values: any) => {
                            this.onEditSubmit(values)
                          }}
                          handleCancel={() => {
                            this.closeEditModal()
                          }}
                        />
                      )}
                    </div>
                  </CommanModal>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state: any) => ({
  vendorData: state.vendor.vendorData,
  vendorDataTotal: state.vendor.vendorDataTotal,
  vendorLoading: state.vendor.vendorLoading,
})

const mapDispatchToProps = (dispatch: any) => {
  return {
    setListVendorData: (vendorData: any) => {
      dispatch(vendor.actions.setVendorData(vendorData))
    },
    setListVendorDataTotal: (vendorDataTotal: number) => {
      dispatch(vendor.actions.setVendorDataTotal(vendorDataTotal))
    },
    setVendorLoading: (vendorLoading: boolean) => {
      dispatch(vendor.actions.setVendorLoading(vendorLoading))
    },
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(ListVendorData))
